/**
 * Debounce time for flushing spans on error.
 * This is to avoid redundant flushes when multiple requests fail concurrently.
 */
export const FLUSH_DEBOUNCE_MS = 100;
